// Candle Anatomy correction line: one plain-language sentence per mistake,
// built from where the learner actually tapped and where the element really is
// (see core/revealModel.js), e.g.
//   "You marked the bottom of the body. Open belongs at the top of the body."
// Body is a region, so it says what the region is. Wick names the specific
// wick it was corrected to (client: keep the pattern position-specific, no
// vague exception the reusable system would have to carry).
export function correctionLine(m) {
  const you = `You marked ${m.yourPlace.long}.`;
  if (m.id === "body") return `${you} The body belongs between the open and the close.`;
  if (m.id === "wick")
    return m.correctPlace.short === "Upper wick"
      ? `${you} The upper wick belongs above the body.`
      : `${you} The lower wick belongs below the body.`;
  return `${you} ${m.label} belongs at ${m.correctPlace.long}.`;
}
